import React, { FC, ReactNode } from 'react';
import { FieldRenderProps } from 'react-final-form';

import { Checkbox, CheckboxWithLabel, CheckboxWithLabelProps } from 'Modules/ui3';


type CheckboxProps = Omit<CheckboxWithLabelProps, 'label'> & {
    label?: ReactNode;
}

export type CheckboxFieldProps = FieldRenderProps<boolean> & CheckboxProps;

export const CheckboxField: FC<CheckboxFieldProps> = ({
    input,
    meta,
    label,
    ...props
}) =>
    label ? (
        <CheckboxWithLabel label={label} {...input} {...props} />
    ) : (
        <Checkbox {...input} {...props} />
    );
